import "../css/reviews.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";

library.add(fas, fab);

export default function Reviews() {
  useGSAP(() => {
    gsap.registerPlugin(ScrollTrigger);

    gsap.utils.toArray(".review-card").forEach((card) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: card,
          start: "40% 80%",
          toggleActions: "play none none none",
        },
      });

      tl.from(card.querySelectorAll(".review-author"), {
        opacity: 0,
        y: 30,
        duration: 0.5,
        ease: "power2.out",
      });

      // Animate the image wrapper differently
      tl.from(card.querySelector(".review-text"), {
        opacity: 0,
        y: 30,
        duration: 0.25,
        ease: "power1.out",
      });
    });
  });
  return (
    <section className="review-section">
      <div className="review-main-container">
        <div className="review-header">
          <h1>Lives We’ve Helped</h1>
        </div>
        <div className="reviews-grid">
          <div className="review-card">
            <div className="review-text">
              <p>
                "Hilary is amazing. We feel so blessed to have her as our Trust
                Attorney. Hilary is extremely thorough and detailed. My husband
                and I feel at ease with peace of mind that our affairs are in
                order for the present and future."
              </p>
            </div>
            <div className="review-author">
              <p>Marilyn M. | August 2025</p>
              <div>
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
              </div>
            </div>
          </div>
          <div className="review-card">
            <div className="review-text">
              <p>
                "We recently had the privilege of working with Hilary Lawrence
                from Lawrence Trust and Estate Law to establish our family trust
                and living will. Hilary exhibited extensive knowledge and
                attention to detail throughout the process and was truly a
                pleasure to work with. We highly recommend her and Lawrence
                Trust and Estate Law to anyone seeking assistance in creating a
                trust or living will."
              </p>
            </div>
            <div className="review-author">
              <p>Liz C. | July 2025</p>
              <div>
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
              </div>
            </div>
          </div>
          <div className="review-card">
            <div className="review-text">
              <p>
                "My wife and I had a great experience with Lawrence Trust and
                Estate Law. Super insightful, knowledgeable and patient, taking
                the time to explain, clarify and answer questions in a manner
                appropriate for each of us individually. If like us you've been
                putting this off... don't wait any longer, Hilary will see you
                through the process!"
              </p>
            </div>
            <div className="review-author">
              <p>Mike B. | April 2025</p>
              <div>
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
              </div>
            </div>
          </div>

          <div className="review-card">
            <div className="review-text">
              <p>
                "Our experience with Hilary Lawrence was exceptional. She was
                very patient and knowledgeable about estate planning. She went
                through each document and explained everything thoroughly. We
                highly recommend her and would gladly use her services again. "
              </p>
            </div>
            <div className="review-author">
              <p>Christine & Dean C. | March 2025</p>
              <div>
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
              </div>
            </div>
          </div>
          <div className="review-card">
            <div className="review-text">
              <p>
                "We had a wonderful experience working with Hilary, our living
                trust attorney. She was incredibly thorough in answering all of
                our questions and addressed every possible scenario when
                preparing our living trust. Her professionalism and attention to
                detail gave us peace of mind, knowing that everything was taken
                care of. We highly recommend her services!"
              </p>
            </div>
            <div className="review-author">
              <p>Mijung J. | February 2025</p>
              <div>
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
              </div>
            </div>
          </div>
          <div className="review-card">
            <div className="review-text">
              <p>
                "I recently had the pleasure of working with Hilary to update my
                family's estate planning documents, including our will and
                trust. I cannot recommend Hilary highly enough - she was truly
                exceptional to work with. From the initial consultation, Hilary
                demonstrated deep expertise in estate planning. She took the
                time to thoroughly understand our family's unique needs and
                goals, then carefully guided us through the available options to
                ensure the right plan was in place. Hilary was patient,
                explained complex topics clearly, and was always available to
                answer our questions. I highly recommend her services to anyone
                in need of estate planning assistance."
              </p>
            </div>
            <div className="review-author">
              <p>Gerry C. | 2024</p>
              <div>
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-star"
                  className="star-review"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
